import FormattedMessage from 'I18n/components/FormattedMessage';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import UILink from 'UIComponents/link/UILink';
import { getPaidUserSettingsUrl } from '../../urls/getPaidUserSettingsUrl';
import { getUsersSeatsUrl } from '../../urls/getUsersSeatsUrl';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ScopeFilteringTeamOption = ({
  option
}) => {
  return /*#__PURE__*/_jsxs(UIFlex, {
    "data-test-id": "reassignment-dropdown-team",
    justify: "start",
    style: Object.assign({
      padding: '8px',
      paddingRight: '16px'
    }, option.dropdownStyle),
    children: [option.text, option.containsFreeUsers && /*#__PURE__*/_jsx(UIHelpIcon, {
      className: "m-left-1 m-right-2",
      title: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'routing-ui.users-and-teams.tooltips.team-no-service-seat-user-routing.description'
          })
        }), /*#__PURE__*/_jsx("p", {
          className: "m-y-0",
          children: /*#__PURE__*/_jsx(UILink, {
            external: true,
            href: getUsersSeatsUrl(),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: 'routing-ui.users-and-teams.tooltips.team-no-service-seat-user-routing.manage-link'
            })
          })
        })]
      })
    })]
  });
};
ScopeFilteringTeamOption.displayName = 'ScopeFilteringTeamOption';
const DeprecatedTeamOption = ({
  option
}) => {
  return /*#__PURE__*/_jsxs(UIFlex, {
    "data-test-id": "reassignment-dropdown-team",
    justify: "between",
    style: Object.assign({
      padding: '8px',
      paddingRight: '16px'
    }, option.dropdownStyle),
    children: [option.text, option.containsFreeUsers && /*#__PURE__*/_jsx(UIHelpIcon, {
      className: "m-right-2",
      title: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'routing-ui.users-and-teams.tooltips.team-free-user-routing.description'
          })
        }), /*#__PURE__*/_jsx("p", {
          className: "m-y-0",
          children: /*#__PURE__*/_jsx(UILink, {
            external: true,
            href: getPaidUserSettingsUrl(),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: 'routing-ui.users-and-teams.tooltips.team-free-user-routing.manage-link'
            })
          })
        })]
      })
    })]
  });
};
DeprecatedTeamOption.displayName = 'DeprecatedTeamOption';
const TeamOption = ({
  option,
  isUngatedForHelpDeskRoutingScopeFiltering
}) => {
  const Component = isUngatedForHelpDeskRoutingScopeFiltering ? ScopeFilteringTeamOption : DeprecatedTeamOption;
  return /*#__PURE__*/_jsx(Component, {
    option: option
  });
};
TeamOption.displayName = 'TeamOption';
export default TeamOption;